import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/login/logo.png';
import _imports_1 from '@/assets/login/title.png';
const _withScopeId = n => (_pushScopeId("data-v-f485be68"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "login-page position-relative"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo_",
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "title",
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_4 = {
  class: "login-content"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text_titles"
}, "账号登录", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text_bottoms"
}, "星粉严选&你让世界更美", -1));
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import accoutAction from "./components/accout-action.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'login',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const tabsActive = ref("accout");
    onMounted(() => {
      document.title = "登录";
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", null, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, tabsActive.value === 'accout' ? (_openBlock(), _createBlock(accoutAction, {
        key: 0,
        class: "accout_box"
      })) : _createCommentVNode("", true), _hoisted_6])])]);
    };
  }
});